/** Bounded FIFO without Array.shift/splice or per-byte allocations. */
export class ByteQueue {
  private bytes: Uint8Array;
  private head = 0;
  length = 0;
  constructor(capacity = 4096) {
    this.bytes = new Uint8Array(capacity);
  }
  push(data: Uint8Array): number {
    const count = Math.min(data.length, this.bytes.length - this.length);
    for (let i = 0; i < count; i++)
      this.bytes[(this.head + this.length + i) % this.bytes.length] = data[i];
    this.length += count;
    return data.length - count;
  }
  shift(): number | undefined {
    if (!this.length) return undefined;
    const value = this.bytes[this.head];
    this.head = (this.head + 1) % this.bytes.length;
    this.length--;
    return value;
  }
}
